import {invokeApi} from "../utils/invokeApi";

import CryptoJS from 'crypto-js';

const app_key = 'CPCIx2024aLpHaNum3r1cK3yX9zQ7wT5';
const secret_key = 'S3cR3tK3y2024xYzQw9LpHaNum8r1cV7tB';

const customCipherLib = {
    encode: (data) => {
        const timestamp = new Date().toISOString();
        const payload = { ...data, timestamp };
        let str = JSON.stringify(payload);
        let reversed = str.split('').reverse().join('');
        let salted = app_key + reversed + secret_key;
        return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(salted));
    },
    decode: (encoded) => {
        let decoded = CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(encoded));
        if (!decoded.startsWith(app_key) || !decoded.endsWith(secret_key)) return null;
        let core = decoded.slice(app_key.length, -secret_key.length);
        let unreversed = core.split('').reverse().join('');
        try {
            return JSON.parse(unreversed);
        } catch {
            return null;
        }
    },
    sign: (encoded) => {
        const key = app_key + secret_key;
        return CryptoJS.HmacSHA256(encoded, key).toString(CryptoJS.enc.Hex);
    },
    verify: (encoded, signature) => {
        const expected = customCipherLib.sign(encoded);
        if (expected !== signature) return false;
        const decoded = customCipherLib.decode(encoded);
        if (!decoded || !decoded.timestamp) return false;
        const now = new Date();
        const ts = new Date(decoded.timestamp);
        const diffMs = Math.abs(now.getTime() - ts.getTime());
        if (diffMs > 2 * 60 * 1000) return false;
        return true;
    }
};

function makePostData(dataObj) {
    const data = customCipherLib.encode(dataObj);
    const signature = customCipherLib.sign(data);
    return { data, signature, app_key };
}

export const verifyAndDecodeResponse = (responseData) => {
    const { data, signature } = responseData;
    if (!data || !signature) return null;
    if (!customCipherLib.verify(data, signature)) return null;
    return customCipherLib.decode(data);
}

export const getCompetenciesIndexDataService = (country_code, age_group) => {
    let requestObj = {
        path: '/api/cpcIndex/CompetenciesIndex',
        method: 'POST',
    };
    const dataObj = { country_code, age_group };
    requestObj['postData'] = makePostData(dataObj);

    return invokeApi(requestObj);
}

export const countryCodesByAllIndexesService = (created_year) => {
    let requestObj = {
        path: '/api/cpcIndex/Index/country/codes',
        method: 'POST',
    };
    const dataObj = { created_year: created_year || '2024' };
    requestObj['postData'] = makePostData(dataObj);

    return invokeApi(requestObj);
}

export const getDigitalGapsIndexDataService = (country_code, age_group) => {
    let requestObj = {
        path: '/api/cpcIndex/DigitalGapsIndex',
        method: 'POST',
    };
    const dataObj = { country_code, age_group };
    requestObj['postData'] = makePostData(dataObj);

    return invokeApi(requestObj);
}

export const getGoalsIndexDataService = (country_code) => {
    let requestObj = {
        path: '/api/cpcIndex/GoalsIndex',
        method: 'POST',
    };
    const dataObj = { country_code };
    requestObj['postData'] = makePostData(dataObj);

    return invokeApi(requestObj);
}

export const getGoalsIndexAllDataService = () => {
    let requestObj = {
        path: '/api/cpcIndex/GoalsIndexAll',
        method: 'POST',
    };
    const dataObj = {};
    requestObj['postData'] = makePostData(dataObj);

    return invokeApi(requestObj);
}

export const getGoalsPointsIndexDataService = (country_code) => {
    let requestObj = {
        path: '/api/cpcIndex/GoalsPointsIndex',
        method: 'POST',
    };
    const dataObj = { country_code };
    requestObj['postData'] = makePostData(dataObj);

    return invokeApi(requestObj);
}

export const getTargetsIndexDataService = (country_code) => {
    let requestObj = {
        path: '/api/cpcIndex/TargetsIndex',
        method: 'POST',
    };
    const dataObj = { country_code };
    requestObj['postData'] = makePostData(dataObj);

    return invokeApi(requestObj);
}

export const getWeightsIndexDataService = () => {
    let requestObj = {
        path: '/api/cpcIndex/WeightsIndex',
        method: 'POST',
    };
    const dataObj = {};
    requestObj['postData'] = makePostData(dataObj);

    return invokeApi(requestObj);
}

export const getCpciIndexDataService = () => {
    let requestObj = {
        path: '/api/cpcIndex/CpciIndex',
        method: 'POST',
    };
    const dataObj = {};
    requestObj['postData'] = makePostData(dataObj);

    return invokeApi(requestObj);
}

export const getCyberRiskMonitorDataService = () => {
    let requestObj = {
        path: '/api/cpcIndex/CyberRiskMonitor',
        method: 'POST',
    };
    const dataObj = {};
    requestObj['postData'] = makePostData(dataObj);

    return invokeApi(requestObj);
}

export const getCyberRiskTodayDataService = () => {
    let requestObj = {
        path: '/api/cpcIndex/CyberRiskToday',
        method: 'POST',
    };
    const dataObj = {};
    requestObj['postData'] = makePostData(dataObj);

    return invokeApi(requestObj);
}

export const getCpcIndexDetailDataService = (country_code) => {
    let requestObj = {
        path   : '/api/cpcIndex/countryIndex',
        method : 'POST',
    };
    const dataObj = { country_code };
    requestObj['postData'] = makePostData(dataObj);

    return invokeApi(requestObj);
}

export const getCpciGlobalChildProtectionProgressService = () => {
    let requestObj = {
        path   : '/api/cpcIndex/CpciGlobalChildProtectionProgress',
        method : 'POST',
    };
    const dataObj = {};
    requestObj['postData'] = makePostData(dataObj);

    return invokeApi(requestObj);
}

export const contactUsIndexService = async (name, email, message, partnership, targets, cpci_actions) => {
    let requestObj = {
        path   : '/api/cpcIndex/contact_us',
        method : 'POST',
    };
    const dataObj = {
        name,
        email,
        message: message || '',
        partnership: partnership || [],
        targets: targets || [],
        cpci_actions: cpci_actions || [],
    };
    requestObj['postData'] = makePostData(dataObj);
    return invokeApi(requestObj);
}